<template>
    <span
        class="CHeading block font-medium leading-tight"
        :class="{
            'flex justify-between': $slots.end,
            'variant-1': variant == 1,
            'variant-2': variant == 2,
            'section-heading': section,
            'variant-3': variant == 3,
            'variant-4': variant == 4,
            'variant-5': variant == 5,
            'variant-6': variant == 6,
            'fat-italic': variant == 'fat-italic',
            'fat-italic-lg': variant == 'fat-italic-lg',
            'fat-italic-extrabold': variant == 'fat-italic-extrabold'
        }"
    >
        <component :is="headerTag">
            <slot />
        </component>

        <template v-if="$slots.end">
            <slot name="end" />
        </template>
    </span>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface Props {
    variant?: number | string
    tag?: string
    section?: boolean
}

const props = withDefaults(defineProps<Props>(), {
    variant: 1,
    tag: '',
    section: false
})

const headerTag = computed(() => {
    if (
        props.variant === 'fat-italic' ||
        props.variant === 'fat-italic-lg' ||
        props.variant === 'fat-italic-extrabold'
    ) {
        // Styling lives on the wrapper, so a section heading can keep the look as an h2
        return props.tag || 'h1'
    }

    return props.tag ? props.tag : `h${props.variant}`
})
</script>

